//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create standard exam -------------
export const createStandardExams = () => ({ type: ActionTypes.standardexams.createStandardExams });

export const createStandardExamsSuccess = (returnedPayload) => ({ type: ActionTypes.standardexams.createStandardExamsSuccess, payload: returnedPayload });

export const createStandardExamsFail = (returnedPayload) => ({ type: ActionTypes.standardexams.createStandardExamsFail, payload: returnedPayload });

//  -- Update standard exam -------------
export const updateStandardExams = () => ({ type: ActionTypes.standardexams.updateStandardExams });

export const updateStandardExamsSuccess = (returnedPayload) => ({ type: ActionTypes.standardexams.updateStandardExamsSuccess, payload: returnedPayload });

export const updateStandardExamsFail = (returnedPayload) => ({ type: ActionTypes.standardexams.updateStandardExamsFail, payload: returnedPayload });

//  -- Delete standard exam -------------
export const deleteStandardExams = () => ({ type: ActionTypes.standardexams.deleteStandardExams });

export const deleteStandardExamsSuccess = (returnedPayload) => ({ type: ActionTypes.standardexams.deleteStandardExamsSuccess, payload: returnedPayload });

export const deleteStandardExamsFail = (returnedPayload) => ({ type: ActionTypes.standardexams.deleteStandardExamsFail, payload: returnedPayload });

//  -- List standard exams --------------
export const listStandardExamss = () => ({ type: ActionTypes.standardexams.listStandardExams });
export const listStandardExamssFail = (returnedPayload) => ({ type: ActionTypes.standardexams.listStandardExamsFail, payload: returnedPayload });
export const listStandardExamssSuccess = (returnedPayload) => ({ type: ActionTypes.standardexams.listStandardExamsSuccess, payload: returnedPayload });
